import SVG, { CustomSVGWithDirection } from '@/src/components/common/SVG/SVG'

export default function SVGFlatTriangle({ direction, ..._ }: CustomSVGWithDirection) {
  if (!direction) direction = 'right'
  const rotation = {
    up: -180,
    down: 0,
    left: -90,
    right: -270,
  }[direction]
  _.transform = `rotate(${rotation}deg)`
  return (
    <SVG width="10" height="5" viewBox="0 0 10 5" {..._}>
      <path d="M0 0L5 5L10 0H0Z" fill="currentColor" fillOpacity="inherit" />
    </SVG>
  )
}
